import { getAiReportConfig, AiReportInfo, ReportMenuItem } from './aiReport';

export type AiReportConfigResult = {
  aiInfo: AiReportInfo | null;
  supportedReports: ReportMenuItem[];
  showAiButton: boolean;
};

const resultCache = new Map<string, AiReportConfigResult>();
const inflightCache = new Map<string, Promise<AiReportConfigResult>>();

export async function getAiReportConfigCached(reportName: string): Promise<AiReportConfigResult> {
  if (!reportName) {
    return { aiInfo: null, supportedReports: [], showAiButton: false };
  }

  if (resultCache.has(reportName)) {
    return resultCache.get(reportName)!;
  }

  const inflight = inflightCache.get(reportName);
  if (inflight) {
    return inflight;
  }

  const promise = getAiReportConfig(reportName)
    .then(res => {
      resultCache.set(reportName, res);
      inflightCache.delete(reportName);
      return res;
    })
    .catch(err => {
      inflightCache.delete(reportName);
      throw err;
    });

  inflightCache.set(reportName, promise);
  return promise;
}